import {fichaDeControl, params, recommendation} from './state';

/**
 * Establecer id_empresa
 */
export function establecerIdEmpresa(state, id_empresa) {
    state.id_empresa = id_empresa;
}

/**
 * Establecer estándares
 */
export function establecerEstandares(state, estandares) {
    state.estandares = estandares;
}

/**
 * Establecer ficha de control
 */
export function establecerFichaDeControl(state, ficha_de_control) {

    state.ficha_de_control = fichaDeControl();

    if (ficha_de_control) {

        state.ficha_de_control.fecha = ficha_de_control.fecha;
        state.ficha_de_control.id_tarea = ficha_de_control.id_tarea;

        ficha_de_control.estandares.map(e => {
            state.ficha_de_control.estandares.push(e.id_estandar);
        });

    }
}

/**
 * Establecer recomendaciones ficha de control
 */
export function establecerRecomendacionesFichaDeControl(state, ficha_de_control) {
    if (ficha_de_control) {
        state.recomendaciones.map(re => {
            re.tipos_recomendaciones.map(tr => {
                tr.recomendaciones.map(r => {
                    ficha_de_control.estandares.map(ef => {
                        ef.recomendaciones.map(rf => {
                            if (ef.id_estandar === re.id && r.id === rf.id_recomendacion) {
                                r.seleccionado = true;
                                r.worker_control = !!rf.worker_control;
                                r.company_control = !!rf.company_control;
                                if (r.descripcion_personalizada !== rf.recomendacion) {
                                    r.descripcion_personalizada = rf.recomendacion;
                                }
                            }
                        });
                    });
                });
            });
        });
    }
}

/**
 * Establecer tarea
 */
export function establecerTarea(state, tarea) {
    state.tarea = tarea;
    state.ficha_de_control.id_tarea = tarea.id;
    state.ficha_de_control.id_empresa = tarea.id_empresa;
}

/**
 * Establecer id empresa de la ficha de control
 */
export function setFichaDeControlIdEmpresa(state, id_empresa) {
    state.ficha_de_control.id_empresa = id_empresa;
}

/**
 * Establecer recomendaciones
 */
export function establecerRecomendaciones(state, recomendaciones) {

    recomendaciones.map(re => {

        const recomendacion_estandar = state.recomendaciones_temporales.find(ret => ret.id === re.id);

        re.filtro = '';

        if (recomendacion_estandar) {
            re.filtro = recomendacion_estandar.filtro;
        }

        re.tipos_recomendaciones.map(tr => {
            tr.recomendaciones.map(r => {
                r.seleccionado = false;
                state.recomendaciones_temporales.map(ret => {
                    ret.tipos_recomendaciones.map(trt => {
                        trt.recomendaciones.map(rt => {
                            if (rt.id === r.id && rt.id_tipo_recomendacion === r.id_tipo_recomendacion) {
                                r.seleccionado = rt.seleccionado;
                                r.descripcion_personalizada = rt.descripcion_personalizada;
                            }
                        });
                    });
                });
            });
        });
    });

    state.recomendaciones = recomendaciones;
}

/**
 * Establecer recomendaciones
 */
export function establecerRecomendacionesTemporales(state) {

    state.recomendaciones_temporales = state.recomendaciones;
}

/**
 * Copiar recomendación a la recomendación personalizada
 */
export function copiarRecomendacion(state, recomendacion) {
    state.recomendaciones.map(re => {
        re.tipos_recomendaciones.map(tr => {
            tr.recomendaciones.map(r => {
                if (r.id === recomendacion.id && r.id_tipo_recomendacion === recomendacion.id_tipo_recomendacion) {
                    r.descripcion_personalizada = r.descripcion;
                }
            });
        });
    });
}

/**
 * Establecer las recomendaciones de la ficha de control
 */
export function establecerFichaDeControlRecomendaciones(state) {

    let recomendaciones = [];

    state.recomendaciones.map(re => {
        re.tipos_recomendaciones.map(tr => {
            tr.recomendaciones.map(r => {
                if (r.seleccionado && r.estandares && r.estandares[0]) {
                    const recomendacion = {
                        id_recomendacion: r.id,
                        id_estandar: r.estandares[0].id_estandar,
                        recomendacion: r.descripcion_personalizada.trim() !== '' ? r.descripcion_personalizada : r.descripcion,
                        worker_control: !!r.worker_control,
                        company_control: !!r.company_control
                    };

                    recomendaciones.push(recomendacion);
                }
            });
        });
    });

    state.ficha_de_control.recomendaciones = recomendaciones;
}

/**
 * Establecer un valor para la variable standards.
 */
export function setStandards(state, standards) {
    state.standards = standards;
}

/**
 * Establecer un valor para la variable recommendations.
 */
export function setRecommendations(state, recommendations) {
    state.recommendations = recommendations;
}

/**
 * Establecer el valor por defecto de la variable params.
 */
export function resetParams(state) {
    state.params = params();
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setShowToModal(state, show) {
    state.modal.show = show;
}

/**
 * Establecer el valor por defecto de la variable recommendation.
 */
export function resetRecommendation(state) {
    state.recommendation = recommendation();
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable recommendation.
 */
export function setRecommendation(state, recommendation) {
    state.recommendation = recommendation;

    if (recommendation.estandares && recommendation.estandares[0]) {
        state.recommendation.id_estandar = recommendation.estandares[0].id_estandar;
    }
}

/**
 * Establecer un valor para la variable recommendation_types.
 */
export function setRecommendationTypes(state, recommendation_types) {
    state.recommendation_types = recommendation_types;
}
